'use strict';

export const ASSET_LIST_NAME = 'assetProjects';
export const ASSET_LIST_PREFIX = `@@${ASSET_LIST_NAME}`;

export const CREATE_PROJECT_NAME = 'createProject';
export const CREATE_PROJECT_PREFIX = `@@${CREATE_PROJECT_NAME}`;

export const DELETE_PROJECT_NAME = 'deleteProject';
export const DELETE_PROJECT_PREFIX = `@@${DELETE_PROJECT_NAME}`;

export const DELETE_ASSET_PROJECT_NAME = 'deleteAssetProject';
export const DELETE_ASSET_PROJECT_PREFIX = `@@${DELETE_ASSET_PROJECT_NAME}`;

export const UPDATE_PROJECT_NAME = 'updateProject';
export const UPDATE_PROJECT_PREFIX = `@@${UPDATE_PROJECT_NAME}`;



// WEBPACK FOOTER //
// ./src/js/projects/redux/state.js